import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import { toast } from 'react-toastify';
import axios from 'axios'; // API isteği için axios import edelim

const PasswordModal = ({ isOpen, toggle, employee, apiEndpoint }) => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (!isOpen) {
            setPassword('');
            setConfirmPassword('');
            setError('');
        }
    }, [isOpen]);

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
        if (error) setError('');
    };

    const handleConfirmPasswordChange = (e) => {
        setConfirmPassword(e.target.value);
        if (error) setError('');
    };

    const validatePasswords = () => {
        if (!password) {
            setError('Şifre alanı boş bırakılamaz.');
            return false;
        }
        if (password !== confirmPassword) {
            setError('Girilen şifreler eşleşmiyor.');
            return false;
        }
        
        if (password.length < 6) {
            setError('Şifre en az 6 karakter olmalıdır.');
            return false;
        }
        setError('');
        return true;
    };

    const handleConfirm = async () => {
        if (!validatePasswords()) {
            return;
        }

        if (!employee || !employee.id) {
            toast.error('Çalışan bilgisi bulunamadı.');
            return;
        }

        // API endpoint'ini dinamik olarak oluştur (Backend yapısına göre ayarlayın)
        // ÖNEMLİ: Backend'inizin şifre belirleme endpoint'ine göre bu URL'i güncelleyin!
        // Örnek: /api/User/{userId}/set-password veya /api/Account/set-password/{userId}
        const setPasswordEndpoint = `${apiEndpoint}/${employee.id}/set-password`;

        console.log(`[PasswordModal] Setting password for employee ${employee.id} at ${setPasswordEndpoint}`);

        try {
            // Veri anahtarı 'newPassword' olarak güncellendi
            await axios.post(setPasswordEndpoint, { newPassword: password }); // Veya axios.put

            toast.success(`${employee.firstName || 'Çalışan'}'ın şifresi başarıyla güncellendi!`);
            toggle(); // Modalı kapat
        } catch (err) {
            console.error("[PasswordModal] Password set error:", err.response?.data || err.message);
            const errorMsg = err.response?.data?.message || err.response?.data?.title || 'Şifre güncellenirken bir hata oluştu.';
            toast.error(errorMsg);
            setError(errorMsg); // Hata mesajını modal içinde de gösterebiliriz
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>
                Şifre Belirle ({employee ? `${employee.firstName} ${employee.lastName}` : 'Çalışan'})
            </ModalHeader>
            <ModalBody>
                <FormGroup>
                    <Label for="password">Yeni Şifre</Label>
                    <Input
                        type="password"
                        id="password"
                        name="password"
                        value={password}
                        onChange={handlePasswordChange}
                        invalid={!!error && error !== 'Girilen şifreler eşleşmiyor.'} // Sadece genel hatalarda invalid yap
                        placeholder="Yeni şifreyi girin"
                    />
                </FormGroup>
                <FormGroup>
                    <Label for="confirmPassword">Yeni Şifre (Tekrar)</Label>
                    <Input
                        type="password"
                        id="confirmPassword"
                        name="confirmPassword"
                        value={confirmPassword}
                        onChange={handleConfirmPasswordChange}
                        invalid={!!error} // Her iki alanı da hata durumunda invalid yap
                        placeholder="Yeni şifreyi tekrar girin"
                    />
                    {/* Hata mesajını FormFeedback olarak göster */}
                    {error && <FormFeedback style={{ display: 'block', marginTop: '0.25rem' }}>{error}</FormFeedback>}
                </FormGroup>
            </ModalBody>
            <ModalFooter>
                <button className="btn btn-pill btn-outline-success" onClick={handleConfirm}>
                    Şifreyi Belirle
                </button>
                <button className="btn btn-pill btn-outline-secondary" onClick={toggle}>
                    İptal
                </button>
            </ModalFooter>
        </Modal>
    );
};

export default PasswordModal;
